export default "__VITE_ASSET__CpivQvWl__"